import { render, staticRenderFns } from "./DialogMessage.vue?vue&type=template&id=31a20742"
import script from "./DialogMessage.vue?vue&type=script&lang=js"
export * from "./DialogMessage.vue?vue&type=script&lang=js"
import style0 from "./DialogMessage.vue?vue&type=style&index=0&id=31a20742&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports